import {ReducerStatuses} from "services/utils/utils";
import {createSlice} from "@reduxjs/toolkit";


export const initialState = {
    status : ReducerStatuses.IDLE,
    error: ""
}

const slice = createSlice({
    name: "temp-password",
    initialState,
    reducers: {
        tempPasswordStart: (state) => {
            state.status = ReducerStatuses.LOADING;
            state.error = initialState.error;
        },
        tempPasswordError: (state, {payload}) => {
            state.status = ReducerStatuses.ERROR;
            state.error = payload;
        },
        tempPasswordSuccess: (state) => {
            state.status = ReducerStatuses.IDLE;
            state.error = initialState.error;
        }
    }
});

const {actions, reducer} = slice;
export const {
    tempPasswordStart, tempPasswordError, tempPasswordSuccess
} = actions;
export default reducer;